module.exports = __webpack_public_path__ + "kudos_59.svg?7c93483d1c5960a09bc3511ff3f2ce84";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_59.svg
// module id = 160
// module chunks = 0